export default [
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/auth/Register.vue'),
        meta: { title: 'register' },
        props: (route) => ({
            holderIdentifier: route.query.holderIdentifier,
            holderEmail: route.query.holderEmail,
            holderFirstName: route.query.holderFirstName,
            holderFirstNameEn: route.query.holderFirstNameEn,
            holderMiddleName: route.query.holderMiddleName,
            holderMiddleNameEn: route.query.holderMiddleNameEn,
            holderLastName: route.query.holderLastName,
            holderLastNameEn: route.query.holderLastNameEn })
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/auth/Login.vue'),
        meta: { title: 'login' }
    },
    {
        path: '/login/result',
        name: 'login/result',
        component: () => import('../views/auth/AuthResult.vue')
    },
    {
        path: '/unauthorized',
        name: 'unauthorized',
        component: () => import('../views/auth/UnAuthorized.vue'),
        meta: { title: 'unauthorizedMessage' }
    },
    {
        path: '/resetPassword',
        name: 'resetPassword',
        component: () => import('../views/auth/ResetPassword.vue'),
        meta: { title: 'resetPassword' }
    },
]
